import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { MdArchive } from 'react-icons/md';
import { toast } from 'react-toastify';

import api from '../../services/apiSgft';
import LightTooltip from './LightTooltip';

export function MassEvidenceExtractionButton() {
	const [loading, setLoading] = React.useState(false);

	async function downloadMatrix() {
		setLoading(true);
		try {
			const response = await api.get(`/extraction/evidence`, {
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				}),
			);
			const link = document.createElement('a');
			const downloadFileName = 'Evidências de Treinamentos.xlsx';
			link.href = url;
			link.setAttribute('download', downloadFileName);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e) {
			toast.error('Erro ao realizar extração', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer ">
			<LightTooltip title="Extrair todas as evidências">
				<IconButton onClick={downloadMatrix}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<MdArchive color="grey" fontSize={'1.6rem'} />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);
}
